<div [hidden]="reportLoading">
    <canvas baseChart         
            [labels]="labels"
            [datasets]="data"            
            [chartType]="'pie'"
            [options]="chartOptions"
            ></canvas>
</div>
<app-report-loading *ngIf="reportLoading"></app-report-loading>